// <head> metadata for CustomerStoriesPage (https://www.dbos.dev/customer-stories).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Customer Stories | DBOS',
    },
    {
      name: 'description',
      content:
        'A library of real-world durable execution and workflow orchestration projects built with DBOS. Use cases, challenges faced, and DBOS results.',
    },
    {
      property: 'og:title',
      content: 'Customer Stories | DBOS',
    },
    {
      property: 'og:description',
      content:
        'A library of real-world durable execution and workflow orchestration projects built with DBOS. Use cases, challenges faced, and DBOS results.',
    },
    {
      name: 'twitter:title',
      content: 'Customer Stories | DBOS',
    },
    {
      name: 'twitter:description',
      content:
        'A library of real-world durable execution and workflow orchestration projects built with DBOS. Use cases, challenges faced, and DBOS results.',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/customer-stories',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
